//@ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'

import { withSystemConfig } from 'shared'
import FormField from '../../shared/newFormElements'
import { SellAmountBProps } from './ConvertOnAccountInCash.types'

@withSystemConfig('CashConvRound')
//@ts-ignore
@connect((state, { FormName }: { FormName: string }) => {
  const selectFormValue = formValueSelector(FormName)

  return {
    rate: selectFormValue(state, 'ccySellRate'),
    ccyBuyRate: selectFormValue(state, 'ccyBuyRate'),
    sellAmountB: selectFormValue(state, 'sellAmountB'),
    sellBCheck: selectFormValue(state, 'sellBCheck'),
    buyACheck: selectFormValue(state, 'buyACheck'),
    alreadyDefinedRates: selectFormValue(state, 'alreadyDefinedRates'),
    creditCCY: selectFormValue(state, 'creditCCY'),
    debitCCY: selectFormValue(state, 'debitCCY'),
  }
})
class SellAmountB extends React.Component<SellAmountBProps> {
  componentDidUpdate(prevProps: SellAmountBProps) {
    const { rate, ccyBuyRate, alreadyDefinedRates, change, sellAmountB } = this.props

    if (
      (rate !== prevProps.rate || ccyBuyRate !== prevProps.ccyBuyRate) &&
      alreadyDefinedRates === '1' &&
      prevProps.sellBCheck === '1' &&
      this.props.debitCCY !== 'GEL'
    ) {
      //@ts-ignore
      change('buyAmountA', rate ? parseFloat(sellAmountB * parseFloat(rate)).toFixed(15) : 0)
    } else if (
      (rate !== prevProps.rate || ccyBuyRate !== prevProps.ccyBuyRate) &&
      alreadyDefinedRates === '1' &&
      prevProps.sellBCheck === '1' &&
      this.props.debitCCY === 'GEL'
    ) {
      change(
        'buyAmountA',
        rate
          ? //@ts-ignore
            (
              Math.round(parseFloat(sellAmountB * parseFloat(rate)).toFixed(15) / prevProps.CashConvRound) *
              prevProps.CashConvRound
            )
              .toFixed(1)
              .toString()
          : 0,
      )
    }
  }

  render() {
    const {
      change,
      alreadyDefinedRates,
      disabled,
      rate,
      isRequired,
      OperTypeID,
      CashConvRound,
      debitCCY,
      buyACheck,
      sellBCheck,
    } = this.props

    return (
      //@ts-ignore
      <FormField
        type="float"
        maxLength="15"
        disabled={disabled}
        format
        customOnChange={(value) => {
          const parsedValue = parseFloat(value)
          if (parseFloat(buyACheck) === 0 || parseFloat(sellBCheck) === 0) {
            if (OperTypeID === 7 && parseFloat(CashConvRound) > 0.01 && debitCCY === 'GEL') {
              change(
                'buyAmountA',
                parsedValue && rate
                  ? //@ts-ignore
                    Math.round((parsedValue * parseFloat(rate)).toFixed(15) / CashConvRound) * CashConvRound
                  : 0,
              )
            } else if (alreadyDefinedRates === '1' && this.props.sellBCheck === '1') {
              //@ts-ignore
              change('buyAmountA', parsedValue && rate ? (parsedValue * parseFloat(rate)).toFixed(15) : 0)
            }
          }
        }}
        onFocus={() => {
          if (alreadyDefinedRates === '1') {
            change('buyACheck', '0')
            change('sellBCheck', '1')
          }
        }}
        style={{ marginBottom: 5 }}
        name="sellAmountB"
        required={isRequired}
        autoComplete="off"
      />
    )
  }
}

export default SellAmountB
